import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Row, Col } from "react-bootstrap";
import Iframe from "react-iframe";
import LocaleStrings from "Languages";
import { DOMAIN_NAME } from "Constants";

import { broadcastQA, fetchSessionWiseLiveQA } from "LiveQAAction";

class BroadCastLiveQA extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  closeModal = () => {
    this.props.broadcastQA({ showModal: false });
  };

  render() {
    let { broadcastLiveQA, eventData, selectedSession } = this.props;

    let url =
      eventData && eventData.seocode
        ? `https://${eventData.seocode}.${DOMAIN_NAME}/o/#/live-qa/${selectedSession}`
        : `https://${DOMAIN_NAME}/o/#/`;

    return (
      <div>
        <div>
          <Modal
            className="modal-container broadcast-modal"
            show={
              broadcastLiveQA && broadcastLiveQA.showModal === true
                ? true
                : false
            }
            onHide={this.closeModal}
            animation={true}
          >
            <Modal.Body>
              <div className="broadcast-import-header">
                <div className="broadcast-import-modal-title">
                  {LocaleStrings.polls_qa_text_live_qa}
                </div>
                <button
                  type="button"
                  className="close btn-sm btn-close "
                  onClick={() => this.closeModal()}
                  style={{ marginTop: -60 }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div style={{ padding: "0px 20px 20px" }}>
                <div className="livepoll-oderd-purchase-container">
                  <Iframe
                    url={url}
                    width="100%"
                    height="100%"
                    id="webbrowser"
                    display="initial"
                    position="relative"
                  />
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    livePublishedQAList: state.allPublishesSessionwiseLiveQA,
    broadcastLiveQA: state.broadcastLiveQA,
    eventData: state.userEventDetails, // Get event details
  };
}

export default connect(mapStateToProps, {
  broadcastQA,
  fetchSessionWiseLiveQA,
})(BroadCastLiveQA);
